module.exports = __webpack_public_path__ + "img/Dantam Hair 44.73eb4397.jpg";